import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertAmountFormat'
})
export class ConvertAmountFormatPipe implements PipeTransform {

  // transform(value: number, ...args: unknown[]): string {
  //   return Intl.NumberFormat('nl-NL', { currency: 'EUR',style: 'currency' }).format(value);
  // }

  transform(content:number, locales:string, decimalNumber:number): string {
    return Intl.NumberFormat(locales,{minimumFractionDigits:decimalNumber,maximumFractionDigits:decimalNumber }).format(Number(content))
  }

}
